__webpack_require__.p = "https://test-your-device.equitas.ai/";